<div class="container">
    <div>
        <mat-icon class="icon">cloud_off</mat-icon>
    </div>
    <p>We can't seem to find the page you are looking for.</p>
    <ng-container *ngIf="isAuthenticated; else loginLink">
        <a [routerLink]="dashboardUrl"> Go to the dashboard </a>
    </ng-container>
    <ng-template #loginLink>
        <a [routerLink]="loginUrl"> Go to login </a>
    </ng-template>
</div>
